import { z } from 'zod';

import { taxSavingsSimulatorFormSchema } from '~/landing/core/simulator/tax-savings-simulator';

import { futureSavingsPlannerConstants, riskProfiles } from './constants';

export const futureSavingsPlannerFormSchema = z.object({
  birthDate: z.string().date(),
  initialDeposit: z
    .number()
    .min(futureSavingsPlannerConstants.initialDeposit.min)
    .max(futureSavingsPlannerConstants.initialDeposit.max),
  monthlyPayment: z
    .number()
    .min(futureSavingsPlannerConstants.monthlyPayment.min)
    .max(futureSavingsPlannerConstants.monthlyPayment.max),
  retirementAge: z.coerce.number(),
  riskProfile: z.enum(riskProfiles),
});

export const formSchema = z.object({
  futureSavingsPlanner: futureSavingsPlannerFormSchema,
  taxSavingsSimulator: taxSavingsSimulatorFormSchema,
});
export type FormSchema = z.infer<typeof formSchema>;
